<!--  -->
<template>
  <div class="icomposite-page">
    <screen-panel :isExpand="isOpen" class="panel">
      <!-- <screen-box title="人员类型统计">
        <PeopleTypePie :personTypeData="personTypeData"></PeopleTypePie>
      </screen-box> -->
      <ScreenBoxClick title="人员类型统计" menuCode="040402">
        <PeopleTypePie :personTypeData="personTypeData"></PeopleTypePie>
      </ScreenBoxClick>
      <screen-box title="当前人员流量统计">
        <Traffic> </Traffic>
      </screen-box>
    </screen-panel>

    <screen-panel :isExpand="isOpen" position="right" class="panel">
      <screen-box title="当前访客人员流量统计">
        <TrafficChart style="margin-top: 10px"></TrafficChart>
      </screen-box>
      <screen-box title="在园人数统计">
        <InParkPersonCount style="margin-top: 10px"></InParkPersonCount>
      </screen-box>
    </screen-panel>
  </div>
</template>

<script>
import screenPanel from "../components/ScreenPanel.vue";
import ScreenBox from "../components/ScreenBox.vue";
import ScreenBoxClick from "../components/ScreenBoxClick.vue";
import PeopleTypePie from "../components/PersonTypePie";
import Traffic from "../components/Traffic";
import TrafficChart from "../components/TrafficChart";

import InParkPersonCount from "../components/InParkPersonCount";

export default {
  data() {
    return {
      personTypeData: {},
      isOpen: false,
    };
  },

  components: {
    screenPanel,
    ScreenBox,
    ScreenBoxClick,
    PeopleTypePie,
    Traffic,
    InParkPersonCount,
    TrafficChart,
  },

  beforeDestroy() {
    this.$map.hideMap2D();
  },
  mounted() {
    this.$map.showMap2D();
    this.isOpen = true;

    this.personTypeData = {
      workNum: 3258,
      visitorNum: 175,
      safeNum: 247,
      cleanNum: 149,
    };
  },

  methods: {},
};
</script>
<style lang='scss' scoped>
.panel {
  height: 100%;
  overflow-y: hidden;
}
</style>